<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tuỳ chỉnh hệ thống">
          <div slot="content">
            <div class="container-fluid">
              <div class="row">
                <VAInfoBox v-for="(item, idx) in menuItems"
                           class="col-md-3 col-sm-6 col-xs-12"
                           bg-color="bg-active"
                           :bg-icon="item.iconClass"
                           :title="item.title"
                           :subtitle="item.subTitle"
                           :link="item.link"
                           :key="idx" />
              </div>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import VAInfoBox from '../../components/VAInfoBox'

export default {
  name: 'SettingBoard',
  data () {
    return {
      menuItems: [
        {
          title: 'Mail gửi đi',
          iconClass: 'fa fa-paper-plane',
          subTitle: 'Cấu hình email gửi đi',
          link: '/settings/company-email'
        },
        {
          title: 'Cấu hình email',
          iconClass: 'fa fa-envelope',
          subTitle: 'Cấu hình nội dung email',
          link: '/settings/email-template'
        },
        {
          title: 'Phân loại data',
          iconClass: 'fa fa-gear',
          subTitle: 'Trạng thái xử lý data',
          link: '/settings/data-status',
        },
        {
          title: 'Nguồn data',
          iconClass: 'fa fa-database',
          subTitle: 'Nguồn tạo dữ liệu',
          link: '/settings/data-source',
        },
        {
          title: 'Chỉnh sửa logo',
          iconClass: 'fa fa-image',
          subTitle: 'Chỉnh sửa logo công ty',
          link: '/settings/company-logo',
        }
      ]
    }
  },
  components: {
    'va-box': VABox,
    VAInfoBox,
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/SettingBoard.vue